import { motion } from 'framer-motion';
import { FaInstagram } from 'react-icons/fa';
import { footerLinks, socialLinksData, brandInfo } from '../../data';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  // Map icon types to actual icon components
  const iconMap = {
    instagram: <FaInstagram />,
  };

  const handleNavClick = (e, href) => {
    if (!href.startsWith('#')) return;
    e.preventDefault();
    const element = document.querySelector(href);
    if (element) {
      const offset = 90;
      const elementPosition = element.getBoundingClientRect().top;
      window.scrollTo({
        top: elementPosition + window.pageYOffset - offset,
        behavior: 'smooth',
      });
    }
  };

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-grid">
          {/* Brand */}
          <div className="footer-brand">
            <a href="#home" onClick={(e) => handleNavClick(e, '#home')} aria-label={brandInfo.fullName}>
              <img
                src={brandInfo.logo.horizontalLight}
                alt={brandInfo.fullName}
                className="footer-logo-image"
              />
            </a>
            <p className="footer-description">
              Delivering Kerala government works and private construction projects since 2014.
              Building excellence, one project at a time.
            </p>
            <div className="footer-social">
              {socialLinksData.map((social) => (
                <motion.a
                  key={social.name}
                  href={social.href}
                  className="social-link"
                  target="_blank"
                  rel="noopener noreferrer"
                  whileHover={{ y: -3 }}
                  whileTap={{ scale: 0.95 }}
                  aria-label={social.name}
                >
                  {iconMap[social.iconType]}
                </motion.a>
              ))}
            </div>
          </div>

          {/* Company links */}
          <div className="footer-column">
            <h4 className="footer-title">Company</h4>
            <ul className="footer-links">
              {footerLinks.company.map((item) => (
                <li key={item.name}>
                  <a href={item.href} onClick={(e) => handleNavClick(e, item.href)}>{item.name}</a>
                </li>
              ))}
            </ul>
          </div>

          {/* Services links */}
          <div className="footer-column">
            <h4 className="footer-title">Services</h4>
            <ul className="footer-links">
              {footerLinks.services.map((item) => (
                <li key={item.name}>
                  <a href={item.href} onClick={(e) => handleNavClick(e, item.href)}>{item.name}</a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div className="footer-column">
            <h4 className="footer-title">Contact</h4>
            <ul className="footer-links">
              {footerLinks.contact.map((item) => (
                <li key={item.name}>
                  <a href={item.href}>{item.name}</a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="footer-bottom">
          <p className="footer-copyright">
            &copy; {currentYear} {brandInfo.fullName}. All rights reserved.
          </p>
          <p className="footer-tagline">{brandInfo.tagline}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
